import type {
  AgentArtifact,
  AgentArtifactState,
  AgentResearchOutputType,
  AgentToolCall,
} from "../../../shared/types.ts";

interface ResearchMessageLike {
  content: string;
  artifacts?: AgentArtifact[] | null;
  tool_calls?: AgentToolCall[] | null;
}

export function isResearchLikeMessage(message: ResearchMessageLike): boolean {
  const content = message.content.trim();
  if (message.artifacts?.length) return true;
  if (message.tool_calls?.length) return true;
  if (content.length >= 420) return true;
  return /(##\s+|###\s+|Key findings|Recommendations|Executive summary|Sources|Next steps)/i.test(content);
}

export function inferResearchOutputType(message: ResearchMessageLike): AgentResearchOutputType {
  if (message.artifacts?.length) return "artifact_bundle";
  if (/\bbrief\b|\bcampaign\b/i.test(message.content)) return "brief_draft";
  return "research_memo";
}

export function describeResearchOutputType(outputType: AgentResearchOutputType): string {
  switch (outputType) {
    case "artifact_bundle":
      return "Artifact bundle";
    case "brief_draft":
      return "Brief draft";
    default:
      return "Research memo";
  }
}

export function inferArtifactState(message: ResearchMessageLike): AgentArtifactState {
  return message.artifacts?.length ? "saved" : "unsaved";
}

export function describeArtifactState(state: AgentArtifactState): string {
  return state === "saved" ? "Saved artifact attached" : "Not saved yet";
}

export function inferNextActionLabel(message: ResearchMessageLike): string {
  if (message.artifacts?.length) {
    return "Open the attached artifact or convert the research into a brief.";
  }
  return "Save the research into your corpus or convert it into a brief.";
}
